<template>
  <v-dialog v-model="display" width="600" scrollable :fullscreen="$vuetify.breakpoint.xs" :transition="$vuetify.breakpoint.xs ? `dialog-bottom-transition` : `dialog-transition`" :content-class="$vuetify.breakpoint.xs ? `safe-area-padding-top-dialog` : `safe-area-padding-top safe-area-padding-bottom`">
    <v-card class="p-relative overflow-hidden white--text primary" :class="$vuetify.breakpoint.xs ? `dialog-fullscreen` : ``" rounded="lg">
      <hub-app-bar :title="title" hide-title color="primary" persistent dialog>
        <template slot="actions-left">
          <v-btn
            v-if="this.showError"
            :color="cancelColor"
            class="flex-shrink-1 flexk-grow-1 text-capitalize"
            text
            v-text="'Close'"
            dark
            @click="cancel"
          />
          <v-btn
            v-else-if="!this.hideCancel"
            :disabled="!isValid"
            :color="cancelColor"
            class="flex-shrink-1 flexk-grow-1 text-capitalize"
            text
            v-text="cancelLabel"
            dark
            @click="cancel"
          />
        </template>
        <template slot="actions-right">
           <v-btn
            v-if="!this.showError && !this.hideAction"
            :disabled="!isValid"
            :color="actionColor"
            class="flex-shrink-1 flexk-grow-1 text-capitalize"
            text
            v-text="actionLabel"
            dark
            @click="confirm"
          />
        </template>
      </hub-app-bar>
      <v-card-text
        class="pt-3 px-2 white--text text-center custom-scrollbars alert-dialog-content"
        v-html="dialogMessage"
      ></v-card-text>
      <v-overlay color="primary" opacity="0.85" class="p-absolute" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="white"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
import HubAppBar from '@/components/HubAppBar.vue';

export default {
  components: {
    HubAppBar
  },
  props: {
    title: {
      type: String,
      default() {
        return "Alert";
      },
    },
    actionLabel: {
      type: String,
      default() {
        return "Done";
      },
    },
    cancelLabel: {
      type: String,
      default() {
        return "Cancel";
      },
    },
    actionColor: {
      type: String,
      default() {
        return "secondary";
      },
    },
    cancelColor: {
      type: String,
      default() {
        return "white";
      },
    },
    hideAction: Boolean,
    hideCancel: Boolean,
  },
  data() {
    return {
      display: false,
      loading: false,
      showError: false,

      model: null,

      message: "",
      errorMessage: "",
    };
  },
  computed: {
    isValid() {
      return !this.loading;
    },
    dialogMessage() {
      if (this.showError)
        return this.errorMessage || "<p>An error occured. Try again.</p>";
      return this.message || "<p>This is an alert.</p>";
    },
  },
  methods: {
    init(model) {
      this.showError = false;
      this.loading = false;

      if (!model) {
        this.model = null;
      } else {
        let clonedModel = {...model};
        this.model = clonedModel;
      }
    },
    open(model, message) {
      this.init(model);
      this.message = message;
      this.display = true;
    },
    error(message) {
      this.errorMessage = message;
      this.showError = true;
      this.loading = false;
    },
    confirm() {
      this.loading = true;
      this.$emit("confirm", this.model);
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    },
    close() {
      this.display = false;
    },
  },
};
</script>
<style lang="scss">
  .alert-dialog-content {
    a {
      color: white !important;
    }
  }
</style>